export const dataDerivar = async ({
  regionID = null,
  regiones = [],
  usuarios = [],
  userId = null,
}) => {
  return {
    fieldsById: {
      region_id: {
        label: `Region`,
        type: `select`,
        value: regionID,
        name: `region_id`,
        items: regiones,
        rules: {
          required: true,
        },
      },
      region_user_id: {
        label: `Usuario (Opcional)`,
        type: `select`,
        value: userId,
        name: `region_user_id`,
        items: usuarios,
        rules: {
          required: false,
        },
      },
    },
    sections: {
      fieldsIds: [`region_id`, `region_user_id`],
    },
  }
}
